import { render, staticRenderFns } from "./BusinessMatchResults.vue?vue&type=template&id=408c3c56&scoped=true"
import script from "./BusinessMatchResults.vue?vue&type=script&lang=ts"
export * from "./BusinessMatchResults.vue?vue&type=script&lang=ts"
import style0 from "./BusinessMatchResults.vue?vue&type=style&index=0&id=408c3c56&prod&lang=scss&scoped=true"
import style1 from "./BusinessMatchResults.vue?vue&type=style&index=1&id=408c3c56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408c3c56",
  null
  
)

export default component.exports